import { JSX, useContext, useEffect } from "react";
import { PageSection } from "@app/shared";
import { ColumnConfig, Waffles } from "@app/shared/waffles";
import { UploadExceptionsContext } from "../contexts/UploadExceptionsContext";
import { WizardStepProps } from "../contexts/interfaces";
import { QESAlert } from "../../shared/qes-standards";
import { InvalidItemsTableData, ResultsSummaryTableData } from "@app/shared/provider-change-wizards/interfaces";

const UploadExceptionsReview = (props: WizardStepProps): JSX.Element => {
  const uploadExceptionsContext = useContext(UploadExceptionsContext);

  const reviewColumnConfig: ColumnConfig = {
    invalidItems: {
      displayText: "Invalid Items",
      noFilter: true,
      noSort: true,
      testId: "invalid-items",
    },
    validItems: {
      displayText: "Results Summary",
      noFilter: true,
      noSort: true,
      testId: "results-summary",
    }
  };

  useEffect(() => {
    props.pageIsValid(!uploadExceptionsContext.loading);
  }, [uploadExceptionsContext.loading]);

  return (
    
    <PageSection>

      {uploadExceptionsContext.totalOverwrittenExceptions > 0 && 
        <div className="container mt-3">
          <QESAlert type="warning" persist={true} classNames="mt-3">Uploading this file will update/overwrite {uploadExceptionsContext.totalOverwrittenExceptions} existing and corresponding Specialty Exception{uploadExceptionsContext.totalOverwrittenExceptions == 1 ? '': 's'}</QESAlert>
        </div>
      }

      <div className="container">
        <div className="mb-2">
          <Waffles<InvalidItemsTableData>
            columns={reviewColumnConfig}
            data={uploadExceptionsContext.invalidItems}
            fullWidth={true}
            hideTableHead={uploadExceptionsContext.invalidItems[0].invalidItems.props.children.every((element: JSX.Element) => !element)}
            testId="upload-exceptions__invalid-items"
          />
        </div>
        <div className="mb-2">
          <Waffles<ResultsSummaryTableData>
            columns={reviewColumnConfig}
            data={uploadExceptionsContext.resultsSummary}
            fullWidth={true}
            testId="upload-exceptions__results-summary"
          />
        </div>
      </div>
    </PageSection>
  );
};

export default UploadExceptionsReview;
